import React from "react";
import IconFreeText from "../../components/icons/icon-free-text/icon-free-text";
import IconImageRequest from "../../components/icons/icon-image-request/icon-image-request";
import IconMultipleAnswers from "../../components/icons/icon-multiple-answers/icon-multiple-answers";
import IconNumericStepper from "../../components/icons/icon-numeric-stepper/icon-numeric-stepper";
import { IconProps } from "../../components/icons/icon-props-interface";
import IconSingleAnswer from "../../components/icons/icon-single-answer/icon-single-answer";
import IconYesNo from "../../components/icons/icon-yes-no/icon-yes-no";
import { IQuestionTypeProps } from "./components/follow-up-question/question-types/question-types-props";
import FuqFreeText from "./components/follow-up-question/question-types/free-text/free-text";
import FuqImageRequest from "./components/follow-up-question/question-types/image-request/image-request";
import FuqNumericStepper from "./components/follow-up-question/question-types/numeric-stepper/numeric-stepper";
import FuqMultiChoice from "./components/follow-up-question/question-types/multi-choice/multi-choice";

export enum RETURN_REASON_TYPE {
    CatalogIssue = 1,
    CustomerSelection = 2,
    DeliveryIssue = 3,
    QualityIssue = 4,
    WarehouseIssue = 5,
    Other = 6,    
}

type IReasonType = {
    [key in RETURN_REASON_TYPE]: { value:RETURN_REASON_TYPE, label:string }
};

export const RETURN_REASON_TYPE_MAP: IReasonType = {
    [RETURN_REASON_TYPE.CatalogIssue]: {
        value: RETURN_REASON_TYPE.CatalogIssue, label: 'Catalog issue'
    },
    [RETURN_REASON_TYPE.CustomerSelection]: {
        value: RETURN_REASON_TYPE.CustomerSelection, label: 'Customer selection'
    },
    [RETURN_REASON_TYPE.DeliveryIssue]: {
        value: RETURN_REASON_TYPE.DeliveryIssue, label: 'Delivery issue'
    },
    [RETURN_REASON_TYPE.QualityIssue]: {
        value: RETURN_REASON_TYPE.QualityIssue, label: 'Quality issue'
    },
    [RETURN_REASON_TYPE.WarehouseIssue]: {
        value: RETURN_REASON_TYPE.WarehouseIssue, label: 'Warehouse issue'
    },
    [RETURN_REASON_TYPE.Other]: {
        value: RETURN_REASON_TYPE.Other, label: 'Other'
    },
}

export function reasonTypeList() {
    return Object.keys(RETURN_REASON_TYPE_MAP).map(k => {
        return RETURN_REASON_TYPE_MAP[(k as unknown) as RETURN_REASON_TYPE];
    });
}




export enum FOLLOW_UP_QUESTION_TYPE {
    FreeText = 1,
    ImageRequest = 2,
    MultiChoiceSingleAnswer = 3,
    MultiChoiceMultipleAnswer = 4,
    NumericStepper = 5,
    YesNo = 6,
}

type IFollowUpQuestionType = {
    [key in FOLLOW_UP_QUESTION_TYPE]: { value:FOLLOW_UP_QUESTION_TYPE, label:string, icon:React.FC<IconProps>, component?:React.FC<IQuestionTypeProps> }
};

export const FOLLOW_UP_QUESTION_TYPE_MAP: IFollowUpQuestionType = {
    [FOLLOW_UP_QUESTION_TYPE.FreeText]: { 
        value: FOLLOW_UP_QUESTION_TYPE.FreeText, label: 'Free text', icon: IconFreeText, component: FuqFreeText 
    },
    [FOLLOW_UP_QUESTION_TYPE.ImageRequest]: { 
        value: FOLLOW_UP_QUESTION_TYPE.ImageRequest, label: 'Media request', icon: IconImageRequest, component: FuqImageRequest 
    },
    [FOLLOW_UP_QUESTION_TYPE.MultiChoiceSingleAnswer]: { 
        value: FOLLOW_UP_QUESTION_TYPE.MultiChoiceSingleAnswer, label: 'Multiple choice - select one', icon: IconSingleAnswer, component: FuqMultiChoice 
    },
    [FOLLOW_UP_QUESTION_TYPE.MultiChoiceMultipleAnswer]: { 
        value: FOLLOW_UP_QUESTION_TYPE.MultiChoiceMultipleAnswer, label: 'Multiple choice - select one or more', icon: IconMultipleAnswers, component: FuqMultiChoice 
    },
    [FOLLOW_UP_QUESTION_TYPE.NumericStepper]: { 
        value: FOLLOW_UP_QUESTION_TYPE.NumericStepper, label: 'Numeric stepper', icon: IconNumericStepper, component: FuqNumericStepper 
    },
    [FOLLOW_UP_QUESTION_TYPE.YesNo]: { 
        value: FOLLOW_UP_QUESTION_TYPE.YesNo, label: 'Yes/No', icon: IconYesNo, component: FuqMultiChoice 
    }
};

export function followUpQuestionTypeList() {
    return Object.keys(FOLLOW_UP_QUESTION_TYPE_MAP).map(k => {
        return FOLLOW_UP_QUESTION_TYPE_MAP[(k as unknown) as FOLLOW_UP_QUESTION_TYPE];
    });
}




export enum MEDIA_OPTION_TYPE {
    ONLY_IMAGE = 'ONLY_IMAGE',
    ONLY_VIDEO = 'ONLY_VIDEO',
    IMAGE_AND_VIDEO = 'IMAGE_AND_VIDEO',
};

type IMediaOptionType = {
    [key in MEDIA_OPTION_TYPE]: { value:MEDIA_OPTION_TYPE, label:string }
};

export const MEDIA_OPTION_TYPE_MAP: IMediaOptionType = {
    [MEDIA_OPTION_TYPE.ONLY_IMAGE]: {
        value: MEDIA_OPTION_TYPE.ONLY_IMAGE, label: 'Only images'
    },
    [MEDIA_OPTION_TYPE.ONLY_VIDEO]: {
        value: MEDIA_OPTION_TYPE.ONLY_VIDEO, label: 'Only videos'
    },
    [MEDIA_OPTION_TYPE.IMAGE_AND_VIDEO]: {
        value: MEDIA_OPTION_TYPE.IMAGE_AND_VIDEO, label: 'Images and/or Videos'
    },
};

export function mediaOptionTypeList() {
    return Object.keys(MEDIA_OPTION_TYPE_MAP).map(k => {
        return MEDIA_OPTION_TYPE_MAP[(k as unknown) as MEDIA_OPTION_TYPE];
    });
}